import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import { SR_API_ACTION_SUNLOCK_REGISTER } from 'api/actionTypes';

import log from 'client/lib/log';
import branch from 'client/core/branch';
import postWithState from 'client/actions/postWithState';
import withApiState from 'client/helpers/withApiState';
import getSunlocksListAction from 'client/actions/Sunlock/getSunlocksList';
import { createInitialValues, createFormValidationFn } from 'client/helpers/formikHelpers';

import ButtonDeprecated from 'client/components/ButtonDeprecated';
import SrFormikField from 'client/components/SrFormikField';

const sunlockRegisterDeviceFormFields = [
  {
    id: 'raspberryPiSerialNumber',
    title: 'Raspberry PI Serial Number',
    label: 'You can find it by looking at /proc/cpuinfo in the Raspberry PI.',
    type: 'short_text',
    validations: ['required', 'serialNumber'],
    properties: {
      placeholder: '000000003d1d1c36',
    },
  },
];

@branch()
@withApiState({
  registerSunlockDeviceApiState: {
    action: SR_API_ACTION_SUNLOCK_REGISTER,
  },
})
class SrSunlockRegisterDeviceForm extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    registerSunlockDeviceApiState: PropTypes.object.isRequired,
  };

  _onSubmit = ({ raspberryPiSerialNumber }, formikBag) => {
    const { dispatch } = this.props;
    dispatch(postWithState, {
      action: SR_API_ACTION_SUNLOCK_REGISTER,
      payload: {
        raspberryPiSerialNumber,
      },
    })
      .then(() => {
        formikBag.resetForm();
        return dispatch(getSunlocksListAction);
      })
      .catch((error) => {
        log.error(error);
      });
  };

  render() {
    const { registerSunlockDeviceApiState } = this.props;

    if (registerSunlockDeviceApiState.isBusy) {
      return <div className="loading-gif" />;
    }

    return (
      <Formik
        enableReinitialize
        onSubmit={this._onSubmit}
        initialValues={createInitialValues({
          formFields: sunlockRegisterDeviceFormFields,
        })}
        validate={createFormValidationFn(sunlockRegisterDeviceFormFields)}
        render={(formikBag) => (
          <Form className="p-relative">
            {sunlockRegisterDeviceFormFields.map((formField) => (
              <SrFormikField key={formField.id} formField={formField} formikBag={formikBag} />
            ))}
            {registerSunlockDeviceApiState.error && (
              <div className="formMessage error">
                <span>{registerSunlockDeviceApiState.error.message}</span>
              </div>
            )}
            <ButtonDeprecated type="submit" disabled={!formikBag.isValid}>
              Register Sunlock
            </ButtonDeprecated>
          </Form>
        )}
      />
    );
  }
}

SrSunlockRegisterDeviceForm.displayName = 'SrSunlockRegisterDeviceForm';

export default SrSunlockRegisterDeviceForm;
